import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ProfileComponent } from './profile.component';
import { Shell } from '@app/shell/shell.service';
import { getRoutePath, PlRoute } from '@app/utils/routes';

const routes: Routes = [
  Shell.childRoutes([{ path: getRoutePath(PlRoute.profile, false), component: ProfileComponent }]),
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: [],
})
export class ProfileRoutingModule {}
